import * as yup from 'yup';

import { REQUIRED } from '../errorsText';
import { STORE_DEFAULT } from '../../pages/constants';

export const validationFields = {
  description: yup.string().required(REQUIRED),
  amount: yup.number().positive().required(REQUIRED),
  messageId: yup.string().required(REQUIRED),
  messages: yup.array(),
  storeIdEq: yup.string().required(REQUIRED),
  comment: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (messages, stores) => {
  const storeValue = stores
    ?.filter((item) => item?.name?.includes(STORE_DEFAULT))
    .map((item) => item.id)[0];
  const initialValues = {
    description: '',
    amount: 0,
    messageId: '',
    messages: messages,
    storeIdEq: storeValue,
    comment: '',
  };

  return initialValues;
};
